export { default } from './FloatingContent';
